import {
  ButtonHTMLAttributes,
  FC,
  HTMLAttributes,
  ReactNode,
  useState,
} from 'react';
import { Collapse } from 'react-collapse';

import { ChevronDownIcon, MinusIcon, PlusIcon } from '@components/common/Icons';
import cx from 'classnames';

export interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
  iconColorClassName?: string;
  initialState?: boolean;
  label: ReactNode;
  arrowIcons?: boolean;
  btnProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

const Accordion: FC<AccordionProps> = ({
  label,
  initialState = false,
  children,
  iconColorClassName,
  btnProps = {},
  arrowIcons = false,
  ...props
}) => {
  const [open, setOpen] = useState(initialState);
  return (
    <div {...props}>
      <button
        className={cx(
          `flex items-center justify-between w-full p-4`,
          btnProps.className,
        )}
        {...btnProps}
        onClick={() => setOpen(!open)}
      >
        <strong className="flex-grow text-left">{label}</strong>

        {arrowIcons ? (
          <ChevronDownIcon
            className={cx(
              'flex-shrink-0 w-5 h-5 transition-transform',
              { 'rotate-180': open },
              iconColorClassName,
            )}
          />
        ) : (
          <>
            {open ? (
              <MinusIcon
                className={cx('flex-shrink-0 w-5 h-5', iconColorClassName)}
              />
            ) : (
              <PlusIcon
                className={cx('flex-shrink-0 w-5 h-5', iconColorClassName)}
              />
            )}
          </>
        )}
      </button>
      <Collapse isOpened={open}>
        <div className="pb-4">{children}</div>
      </Collapse>
    </div>
  );
};

export default Accordion;
